import styled from 'styled-components';

import { Card } from '../../designComponents';
import {
  flexCenter,
  flexSpaceBetween,
  scrollCss,
} from '../../style/reusableStyle';

export const NotificationContainerStyled = styled.div`
  padding: 36px 80px 76px 43px;
  display: flex;
  flex-direction: column;
  & .top-column .right-part .role-color {
    flex-shrink: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;

    & .tabs-label-container {
      gap: 0;
      display: flex;
      justify-content: space-around;

      & .tab {
        padding: 5px;
      }
    }

    & .individual-notification {
      width: 100%;
      padding: 0px 12px 0px 0px;
      display: flex;
      flex-direction: column;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    max-width: 100%;
    padding: 0;
    & .tabs-label-container {
      gap: 0;
      & .tab {
        padding: 5px;
        color: red;
      }
    }

    & .individual-notification {
      width: 100%;
      padding: 0px 12px 0px 0px;
      display: flex;
      flex-direction: column;

      & .notificationTitle {
        font-size: 12px;
      }

      & .createdDate {
        line-height: normal;
      }
      & .icon {
        display: none;
      }
    }
  }
`;
export const NotificationCardWrapper = styled(Card)`
  padding: 12px 0px;

  width: 100%;
  background-color: ${({ theme }) => theme.colors.lighterBackground};
  ${scrollCss}

  & .individual-notification {
    width: 100%;
    padding: 6px 12px 6px 0px;
    background-color: ${({ theme }) => theme.colors.lighterBackground};
    display: flex;
    flex-direction: column;

    & .top-column,
    .bottom-column {
      ${flexSpaceBetween(0)};
      align-items: center;

      & .left-part,
      .right-part {
        display: flex;
        gap: 12px;
        align-items: center;
        b {
          color: red;
          font-weight: 600;
        }

        & .red-dot {
          height: 8px;
          width: 8px;
          ${flexCenter(0)};
          background: ${({ theme }) => theme.colors.red.strong};
          border-radius: 50%;
        }

        & .role-color {
          width: 11px;
          height: 11px;
          border-radius: 50%;
          flex-shrink: 0;
        }
      }

      & .actions-wrapper {
        padding-left: 46px;
        width: 100%;
        ${flexSpaceBetween(20)};
        margin-top: 12px;
      }
    }
  }
`;
